import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api";

export const getDataBanner = createAsyncThunk("services/investingStartups/getDataBanner", async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const response = await api.get(
      "/api/OfferingInvestinginStartups/OfferingHeadSection"
    );
    return response.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

export const getDataStartup = createAsyncThunk(
  "services/investingStartups/getDataStartup",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const response = await api.get(
        "/api/OfferingInvestinginStartups/GetOfferingCategoriesServices"
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  banner: [],
  startup: [],
  isLoading: false,
  error: null,
};

export const investingStartups = createSlice({
  name: "investingStartups",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getDataBanner.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDataBanner.fulfilled, (state, action) => {
        state.isLoading = false;
        state.banner = action.payload;
      })
      .addCase(getDataBanner.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(getDataStartup.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDataStartup.fulfilled, (state, action) => {
        state.isLoading = false;
        state.startup = action.payload;
      })
      .addCase(getDataStartup.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default investingStartups.reducer;
